document.addEventListener("DOMContentLoaded", () => {
  (async function freeProductBar() {
      if(document.querySelector('.free-product-bar')){
          const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();

          const cartDot = document.querySelector('cart-dot')
          const threshold = Number(document.querySelector('.free-product-bar').getAttribute('threshold'));
          const giftId = Number(document.querySelector('.free-product-bar').getAttribute('variant-id'));
          let thresholdReached = false;
          let giftInCart = false;
          let giftKey;

          if (cartContent.total_price > threshold) thresholdReached = true;

          if (cartContent && cartContent.items.length > 0) {
              for (const item of cartContent.items) {
                  for (const property in item.properties ) {
                      if (property == "_gift") {
                          giftInCart = true;
                          giftKey = item.key;
                          break;
                      }
                  }
              }
          }

          function addFreeProduct(freeProductID) {
              let formData = {
              'items': [{
              'id': freeProductID,
              'quantity': 1,
              'properties': {
                  '_gift': 'true'
              }
              }]
              };
              if(giftInCart) return;
              fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify(formData)
              })
              .then(() => {
                  if (window.themeVariables.settings.pageType === "cart") {
                      location.reload()
                  } else {
                      document.dispatchEvent(new CustomEvent("cart:refresh"));
                  }
                  cartDot.innerHTML = cartContent.item_count + 1;
              })
              .catch((error) => {console.error('Error:', error);});
          }

          function removeFreeProduct(freeProductKey) {
              fetch(window.Shopify.routes.root + 'cart/change.js', {
              method: 'POST',
              headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({
                  id: freeProductKey,
                  quantity: 0,
                  sections: ["sections--22807016931593__cart-drawer"]
              })
              })
              .then(() => {
                  if (window.themeVariables.settings.pageType === "cart") {
                      location.reload()
                  } else {
                      document.dispatchEvent(new CustomEvent("cart:refresh"));
                  }
                  cartDot.innerHTML = cartContent.item_count - 1 || '';
              })
              .catch((error) => {console.error('Error:', error);});
          }

          if (thresholdReached && !giftInCart && giftId && !localStorage.getItem("block_free_product")) {
              addFreeProduct(giftId);
          } else if (!thresholdReached && giftInCart && giftKey) {
              removeFreeProduct(giftKey);
              localStorage.removeItem("block_free_product");
          } else if (!thresholdReached){
              localStorage.removeItem("block_free_product");
          }
      }
      document.addEventListener("cart:change", ()=>{
          setTimeout(()=>{freeProductBar()})
      });
  })();
});

// Size guide opener - wait for DOM to be ready
document.addEventListener('DOMContentLoaded', () => {

  //helper function to click the Saiz button
  function tryClick() {
    const start = Date.now();
    const btn = document.querySelector('#saiz-widget-button');
    if (btn) {
      btn.click();
    } else if (Date.now() - start < 10000) { // stop after 10s
      setTimeout(tryClick, 100);
    }
  }

  //helper function to handle the text of the size guide opener
  function handleTextSizeGuideOpener() {
    const sizeGuideOpener = document.querySelector('.size-guide-opener');
    const saizButton = document.querySelector('#saiz-widget-button');
    const saizButtonSize = document.querySelector('.saiz-recommender-button-size');
    console.log({saizButton, sizeGuideOpener});
    if (saizButton && saizButton.textContent.trim()) {
      if (saizButtonSize && saizButtonSize.textContent.length > 0) {
        sizeGuideOpener.innerText = sizeGuideOpener.getAttribute('data-size-guide-active').replace('{{ size }}', saizButtonSize.textContent.trim());
      } else {
        sizeGuideOpener.innerText = sizeGuideOpener.getAttribute('data-size-guide');
      }
    }
  }

  // helper function to start observing the element
  let currentObserver = null;
  function startObserving(element) {
    if (currentObserver) {
      currentObserver.disconnect();
    }
    currentObserver = new MutationObserver((mutations, obs) => {
      // Only disconnect if the Saiz button actually exists now
      const saizButton = document.querySelector('.saiz-recommender-button');
      const saizButtonContent = document.querySelector('.saiz-recommender-button-content');

      if (saizButton || saizButtonContent) {
        handleTextSizeGuideOpener();
        obs.disconnect();
        currentObserver = null;
      }
    });
    currentObserver.observe(element, {
      childList: true,
      subtree: true
    });

    // Optional: Stop observing after 10 seconds if element never appears
    setTimeout(() => {
      if (currentObserver) {
        currentObserver.disconnect();
        currentObserver = null;
      }
    }, 10000);
  }

  // main function to handle the size guide opener
  const sizeGuideOpener = document.querySelector('.size-guide-opener');
  if (sizeGuideOpener) {
    startObserving(document.body);

    sizeGuideOpener.addEventListener('click', () => {
      setTimeout(() => {
        const saizButtonSize = document.querySelector('.saiz-recommender-button-size');
        if (saizButtonSize) {
          // Create a specific observer for the size button
          const sizeObserver = new MutationObserver((mutations) => {
            handleTextSizeGuideOpener();
            sizeObserver.disconnect();
          });

          sizeObserver.observe(saizButtonSize, {
            childList: true,
            characterData: true,
            subtree: true
          });
        }
      }, 5000);

      tryClick();
    });

    // Handle variant change
    // because section is rerendered on variant change
    document.addEventListener('variant:change', () => {
      const sizeGuideOpener = document.querySelector('.size-guide-opener');
      handleTextSizeGuideOpener();
      sizeGuideOpener.addEventListener('click', () => tryClick());
    });
  }
});

class ProductCardVideo extends HTMLElement {
constructor() {
  super();
  this.pauseVideoButton = this.querySelector('.pause-video-button');
  this.playVideoButton = this.querySelector('.play-video-button');
  const localContainer = this.parentElement;
  const container = this.closest('product-card') || this.closest('.horizontal-product-card') || this.closest('.media-grid__item');
  this.videoMedia = localContainer?.querySelector('video-media') || container?.querySelector('video-media');
  this.video = localContainer?.querySelector('video') || container?.querySelector('video');
  this.animatedImage = localContainer?.querySelector('.media-grid__animated-image') || null;
  this.staticImage = localContainer?.querySelector('.media-grid__static-image') || null;
  this.isGif = Boolean(this.animatedImage && this.staticImage);
  this.isGifPlaying = this.isGif;

  if (!this.pauseVideoButton || !this.playVideoButton || (!this.videoMedia && !this.video && !this.isGif)) return;

  this.handlePause = this.handlePause.bind(this);
  this.handlePlay = this.handlePlay.bind(this);
  this.handleState = this.handleState.bind(this);

  this.pauseVideoButton.addEventListener('click', this.handlePause);
  this.playVideoButton.addEventListener('click', this.handlePlay);

  if (this.videoMedia) {
    this.videoMedia.addEventListener('media:play', this.handleState);
    this.videoMedia.addEventListener('media:pause', this.handleState);
  }

  if (this.video) {
    this.video.addEventListener('play', this.handleState);
    this.video.addEventListener('pause', this.handleState);
  }

  this.handleState();
}

disconnectedCallback() {
  this.pauseVideoButton?.removeEventListener('click', this.handlePause);
  this.playVideoButton?.removeEventListener('click', this.handlePlay);
  this.videoMedia?.removeEventListener('media:play', this.handleState);
  this.videoMedia?.removeEventListener('media:pause', this.handleState);
  this.video?.removeEventListener('play', this.handleState);
  this.video?.removeEventListener('pause', this.handleState);
}

handlePause(event) {
  event.preventDefault();
  event.stopPropagation();

  if (this.videoMedia) {
    this.videoMedia.pause();
  } else if (this.isGif) {
    this.isGifPlaying = false;
    this.handleState();
  } else {
    this.video.pause();
  }
}

handlePlay(event) {
  event.preventDefault();
  event.stopPropagation();

  if (this.videoMedia) {
    this.videoMedia.play();
  } else if (this.isGif) {
    this.isGifPlaying = true;
    this.handleState();
  } else {
    this.video.play();
  }
}

handleState() {
  const isPlaying = this.videoMedia ? this.videoMedia.hasAttribute('playing') : this.isGif ? this.isGifPlaying : !this.video.paused;

  if (this.isGif) {
    this.animatedImage.hidden = !isPlaying;
    this.staticImage.hidden = isPlaying;
  }

  this.hidden = false;
  this.playVideoButton.style.display = isPlaying ? 'none' : 'block';
  this.pauseVideoButton.style.display = isPlaying ? 'block' : 'none';
}
}
customElements.define('product-card-video', ProductCardVideo);

// Helper function to get discount code from cookie or URL parameter
function getDiscountCode() {
  // First try to get from cookie (for reload cases)
  const cookieDiscountCode = document.cookie.split('; ')?.find(row => row.startsWith('discount_code='))?.split('=')[1];

  if (cookieDiscountCode) {
    return cookieDiscountCode;
  }

  // Fallback: check URL parameters (for initial visits to discount links)
  const urlParams = new URLSearchParams(window.location.search);
  let urlDiscountCode = urlParams.get('discount');

  // Additional fallback: check if we're on a redirected discount URL
  // Looking for pattern: /discount/CODENAME in the pathname or referrer
  if (!urlDiscountCode) {
    // Check current pathname for /discount/CODE pattern
    const pathMatch = window.location.pathname.match(/\/discount\/([^\/]+)/);
    if (pathMatch) {
      urlDiscountCode = pathMatch[1];
    }
  }

  // Check referrer for discount code (in case of redirect)
  if (!urlDiscountCode && document.referrer) {
    const referrerPathMatch = document.referrer.match(/\/discount\/([^\/\?]+)/);
    if (referrerPathMatch) {
      urlDiscountCode = referrerPathMatch[1];
    }
  }

  return urlDiscountCode;
}

function md5(r) { var n, t, e, o, u, f, i, a, c, g, C, h = function (r, n) { return r << n | r >>> 32 - n }, l = function (r, n) { var t, e, o, u, f; return o = 2147483648 & r, u = 2147483648 & n, f = (1073741823 & r) + (1073741823 & n), (t = 1073741824 & r) & (e = 1073741824 & n) ? 2147483648 ^ f ^ o ^ u : t | e ? 1073741824 & f ? 3221225472 ^ f ^ o ^ u : 1073741824 ^ f ^ o ^ u : f ^ o ^ u }, d = function (r, n, t, e, o, u, f) { return r = l(r, l(l(function (r, n, t) { return r & n | ~r & t }(n, t, e), o), f)), l(h(r, u), n) }, s = function (r, n, t, e, o, u, f) { return r = l(r, l(l(function (r, n, t) { return r & t | n & ~t }(n, t, e), o), f)), l(h(r, u), n) }, v = function (r, n, t, e, o, u, f) { return r = l(r, l(l(function (r, n, t) { return r ^ n ^ t }(n, t, e), o), f)), l(h(r, u), n) }, m = function (r, n, t, e, o, u, f) { return r = l(r, l(l(function (r, n, t) { return n ^ (r | ~t) }(n, t, e), o), f)), l(h(r, u), n) }, S = function (r) { var n, t = "", e = ""; for (n = 0; n <= 3; n++)t += (e = "0" + (r >>> 8 * n & 255).toString(16)).substr(e.length - 2, 2); return t }; for (a = 1732584193, c = 4023233417, g = 2562383102, C = 271733878, n = (t = function (r) { for (var n, t = r.length, e = t + 8, o = 16 * ((e - e % 64) / 64 + 1), u = new Array(o - 1), f = 0, i = 0; i < t;)f = i % 4 * 8, u[n = (i - i % 4) / 4] = u[n] | r.charCodeAt(i) << f, i++; return f = i % 4 * 8, u[n = (i - i % 4) / 4] = u[n] | 128 << f, u[o - 2] = t << 3, u[o - 1] = t >>> 29, u }(r = function (r) { var n, t, e, o = ""; n = t = 0, e = (r = (r + "").replace(/\r\n/g, "\n").replace(/\r/g, "\n")).length; for (var u = 0; u < e; u++) { var f = r.charCodeAt(u), i = null; f < 128 ? t++ : i = f > 127 && f < 2048 ? String.fromCharCode(f >> 6 | 192) + String.fromCharCode(63 & f | 128) : String.fromCharCode(f >> 12 | 224) + String.fromCharCode(f >> 6 & 63 | 128) + String.fromCharCode(63 & f | 128), null != i && (t > n && (o += r.substring(n, t)), o += i, n = t = u + 1) } return t > n && (o += r.substring(n, r.length)), o }(r))).length, e = 0; e < n; e += 16)o = a, u = c, f = g, i = C, a = d(a, c, g, C, t[e + 0], 7, 3614090360), C = d(C, a, c, g, t[e + 1], 12, 3905402710), g = d(g, C, a, c, t[e + 2], 17, 606105819), c = d(c, g, C, a, t[e + 3], 22, 3250441966), a = d(a, c, g, C, t[e + 4], 7, 4118548399), C = d(C, a, c, g, t[e + 5], 12, 1200080426), g = d(g, C, a, c, t[e + 6], 17, 2821735955), c = d(c, g, C, a, t[e + 7], 22, 4249261313), a = d(a, c, g, C, t[e + 8], 7, 1770035416), C = d(C, a, c, g, t[e + 9], 12, 2336552879), g = d(g, C, a, c, t[e + 10], 17, 4294925233), c = d(c, g, C, a, t[e + 11], 22, 2304563134), a = d(a, c, g, C, t[e + 12], 7, 1804603682), C = d(C, a, c, g, t[e + 13], 12, 4254626195), g = d(g, C, a, c, t[e + 14], 17, 2792965006), a = s(a, c = d(c, g, C, a, t[e + 15], 22, 1236535329), g, C, t[e + 1], 5, 4129170786), C = s(C, a, c, g, t[e + 6], 9, 3225465664), g = s(g, C, a, c, t[e + 11], 14, 643717713), c = s(c, g, C, a, t[e + 0], 20, 3921069994), a = s(a, c, g, C, t[e + 5], 5, 3593408605), C = s(C, a, c, g, t[e + 10], 9, 38016083), g = s(g, C, a, c, t[e + 15], 14, 3634488961), c = s(c, g, C, a, t[e + 4], 20, 3889429448), a = s(a, c, g, C, t[e + 9], 5, 568446438), C = s(C, a, c, g, t[e + 14], 9, 3275163606), g = s(g, C, a, c, t[e + 3], 14, 4107603335), c = s(c, g, C, a, t[e + 8], 20, 1163531501), a = s(a, c, g, C, t[e + 13], 5, 2850285829), C = s(C, a, c, g, t[e + 2], 9, 4243563512), g = s(g, C, a, c, t[e + 7], 14, 1735328473), a = v(a, c = s(c, g, C, a, t[e + 12], 20, 2368359562), g, C, t[e + 5], 4, 4294588738), C = v(C, a, c, g, t[e + 8], 11, 2272392833), g = v(g, C, a, c, t[e + 11], 16, 1839030562), c = v(c, g, C, a, t[e + 14], 23, 4259657740), a = v(a, c, g, C, t[e + 1], 4, 2763975236), C = v(C, a, c, g, t[e + 4], 11, 1272893353), g = v(g, C, a, c, t[e + 7], 16, 4139469664), c = v(c, g, C, a, t[e + 10], 23, 3200236656), a = v(a, c, g, C, t[e + 13], 4, 681279174), C = v(C, a, c, g, t[e + 0], 11, 3936430074), g = v(g, C, a, c, t[e + 3], 16, 3572445317), c = v(c, g, C, a, t[e + 6], 23, 76029189), a = v(a, c, g, C, t[e + 9], 4, 3654602809), C = v(C, a, c, g, t[e + 12], 11, 3873151461), g = v(g, C, a, c, t[e + 15], 16, 530742520), a = m(a, c = v(c, g, C, a, t[e + 2], 23, 3299628645), g, C, t[e + 0], 6, 4096336452), C = m(C, a, c, g, t[e + 7], 10, 1126891415), g = m(g, C, a, c, t[e + 14], 15, 2878612391), c = m(c, g, C, a, t[e + 5], 21, 4237533241), a = m(a, c, g, C, t[e + 12], 6, 1700485571), C = m(C, a, c, g, t[e + 3], 10, 2399980690), g = m(g, C, a, c, t[e + 10], 15, 4293915773), c = m(c, g, C, a, t[e + 1], 21, 2240044497), a = m(a, c, g, C, t[e + 8], 6, 1873313359), C = m(C, a, c, g, t[e + 15], 10, 4264355552), g = m(g, C, a, c, t[e + 6], 15, 2734768916), c = m(c, g, C, a, t[e + 13], 21, 1309151649), a = m(a, c, g, C, t[e + 4], 6, 4149444226), C = m(C, a, c, g, t[e + 11], 10, 3174756917), g = m(g, C, a, c, t[e + 2], 15, 718787259), c = m(c, g, C, a, t[e + 9], 21, 3951481745), a = l(a, o), c = l(c, u), g = l(g, f), C = l(C, i); return (S(a) + S(c) + S(g) + S(C)).toLowerCase() }

class DiscountNotification extends HTMLElement {
constructor() {
  super();
  const discountNotificationMember = localStorage.getItem('discount_banner_member');
  const discountNotificationPromo = localStorage.getItem('discount_banner_promo');
  const discountCode = md5(getDiscountCode());

  // handle member discount banner
  this.memberDiscount = this.querySelector('.discount-banner--member');
  if(this.memberDiscount){
    if(discountNotificationMember !== this.memberDiscount.getAttribute('data-discount-name')){
      localStorage.setItem('discount_banner_member', this.memberDiscount.getAttribute('data-discount-name'));
      this.memberDiscount.removeAttribute('hidden', '');
      setTimeout(() => {
        this.memberDiscount.setAttribute('hidden', '');
      }, 5000);
    }
  }

  // handle promo discount banner
    if(discountCode && !discountNotificationPromo){
      localStorage.setItem('discount_banner_promo', discountCode);
      const discountNotificationElement = document.querySelector(`#discount_banner-${discountCode}`);
      if (discountNotificationElement) {

        const timeToShow = Number(discountNotificationElement.getAttribute('data-time-to-show') * 1000);
        console.log({timeToShow});
        discountNotificationElement.removeAttribute('hidden');
        setTimeout(() => {
          discountNotificationElement.setAttribute('hidden', '');
        }, timeToShow);
      }
    } else if (discountNotificationPromo && discountCode && discountNotificationPromo !== discountCode) {
      localStorage.removeItem('discount_banner_promo');
    } else if (!discountCode ) {
      localStorage.removeItem('discount_banner_promo');
    }

}
}
customElements.define('discount-notification', DiscountNotification);

class PriceList extends HTMLElement {
  constructor() {
    super();
    this.price = this.getAttribute('data-price');
    this.compareAtPrice = this.getAttribute('data-compare-at-price');
    this.discountPercentage = this.getAttribute('data-discount-percentage');
    this.cartItem = this.closest('line-item');
    this.PDP = this.closest('.product-info');

  const discountCode = md5(getDiscountCode());
  const productCollection = this.getAttribute('data-collections');
  const discountCollection = document.querySelector(`#discount_banner-${discountCode}`)?.getAttribute('data-product-collection');
  const discountNotificationMember = localStorage.getItem('discount_banner_member');
  if(discountNotificationMember){
    const memberDiscount = document.querySelector(`#discount_banner-${discountNotificationMember}`)?.getAttribute('data-discount-percentage');
    if(memberDiscount > this.discountPercentage){
      return;
    }
  }

    if (productCollection && productCollection.includes(discountCollection)) {
      if (discountCode && !this.cartItem) {
        const bannerDiscountPercentage = document.querySelector(`#discount_banner-${discountCode}`)?.getAttribute('data-discount-percentage');
        const newPrice = this.price * (1 - bannerDiscountPercentage / 100);

        // Use retry logic for better reliability on page navigation
        const applyDiscount = (attempt = 1, maxAttempts = 5) => {
          const salePrice = this.querySelector('sale-price');
          const compareAtPrice = this.querySelector('compare-at-price');
          const onSaleBadge = this.querySelector('on-sale-badge');

          // Check if required elements exist
          if (!salePrice) {
            if (attempt < maxAttempts) {
              setTimeout(() => applyDiscount(attempt + 1, maxAttempts), 100 * attempt);
            }
            return;
          }

        if (compareAtPrice) {
          // Existing sale item - update prices and badge
          salePrice.innerHTML = `<span class="sr-only">new price</span>${(Shopify.formatMoney(newPrice, "{{amount}}")).replace(".", ",")}€`;
          if (this.compareAtPrice && onSaleBadge){
            const discountAmount = this.compareAtPrice - newPrice;
            const discountRatio = discountAmount / this.compareAtPrice;
            const calculatedDiscountPercentage = Math.round(discountRatio * 100);
            onSaleBadge.innerText = `-${calculatedDiscountPercentage}%`;
          } else if (onSaleBadge) {
            onSaleBadge.innerText = `-${bannerDiscountPercentage}%`;
          }
        } else {
          // Regular price item - convert to sale
          salePrice.innerHTML = `<span class="sr-only">new price</span>${(Shopify.formatMoney(newPrice, "{{amount}}")).replace(".", ",")}€`;
          salePrice.classList.add('text-on-sale');

          const compareAtPriceNode = document.createElement('compare-at-price');
          compareAtPriceNode.classList.add('h6', 'text-subdued', 'line-through');
          compareAtPriceNode.innerHTML = `<span class="sr-only">Regulärer Preis</span>${(Shopify.formatMoney(this.price, "{{amount}}")).replace(".", ",")}€`;
          this.insertBefore(compareAtPriceNode, this.firstChild);
        }

        // PDP specific styling
        if (this.PDP) {
          const compareAtPriceElement = this.querySelector('compare-at-price');
          if (compareAtPriceElement) {
            compareAtPriceElement.classList.remove('h6');
            compareAtPriceElement.classList.add('h4');
          }

          if (!this.querySelector('on-sale-badge')) {
            const badge = document.createElement('on-sale-badge');
            badge.classList.add('badge', 'badge--on-sale');
            badge.innerHTML = `-${bannerDiscountPercentage}%`;
            this.appendChild(badge);
          }
        }
      };

      // Start applying discount with initial delay
      setTimeout(() => applyDiscount(), 150);
    }
  }
}
}
customElements.define('price-list', PriceList);
class BadgeList extends HTMLElement {
constructor() {
  super();
  const productCollection = this.getAttribute('data-collections');
  const discountCode = md5(getDiscountCode());
  const discountNotificationMember = localStorage.getItem('discount_banner_member');
  if(discountNotificationMember){
    const memberDiscount = document.querySelector(`#discount_banner-${discountNotificationMember}`)?.getAttribute('data-discount-percentage');
    const promoDiscount = document.querySelector(`#discount_banner-${discountCode}`)?.getAttribute('data-discount-percentage');
    if(memberDiscount > promoDiscount){
      return;
    }
  }
  if (discountCode) {
    const discountCollection = document.querySelector(`#discount_banner-${discountCode}`)?.getAttribute('data-product-collection');
    const discountPercentage = document.querySelector(`#discount_banner-${discountCode}`)?.getAttribute('data-discount-percentage');
    if (productCollection && productCollection.includes(discountCollection)) {
      if (this.querySelector('on-sale-badge')) {
        this.compareAtPrice = Number(this.getAttribute('data-compare-at-price'));
        this.oldPrice = Number(this?.getAttribute('data-price'));
        this.newPrice = this.oldPrice * (1 - discountPercentage / 100);
        this.discountAmount = this.compareAtPrice - this.newPrice;
        this.discountRatio = this.discountAmount / this.compareAtPrice;
        this.discountPercentage = this.discountRatio * 100;
        this.discountPercentage = Math.round(this.discountPercentage);
        this.querySelector('on-sale-badge').innerHTML = `-${this.discountPercentage}%`;
      }else{
        const badge = document.createElement('on-sale-badge');
        badge.classList.add('badge', 'badge--on-sale');
        badge.innerHTML = `-${discountPercentage}%`;
        this.appendChild(badge);
      }
    }
  }
}
}
customElements.define('badge-list', BadgeList);

// Fix for cart not refreshing on browser back navigation
// The theme only refreshes on bfcache (persisted), but browsers often show cached HTML without bfcache
(function() {
  // Store the current cart token when leaving the page
  let lastKnownCartToken = null;

  // On page load, fetch current cart and compare
  async function checkAndRefreshCart() {
    try {
      const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      const cartDrawer = document.querySelector('cart-drawer');
      const cartDot = document.querySelector('cart-dot');
      const cartCount = document.querySelector('cart-count');

      // Get rendered item count from DOM
      const renderedItems = cartDrawer ? cartDrawer.querySelectorAll('.cart-drawer__items line-item, .cart-drawer__items .line-item').length : 0;
      const renderedDotCount = cartDot ? parseInt(cartDot.innerHTML) || 0 : 0;
      const actualItemCount = cart.item_count;

      // Check if there's a mismatch
      const hasMismatch = renderedItems !== actualItemCount ||
                          renderedDotCount !== actualItemCount ||
                          (lastKnownCartToken && lastKnownCartToken !== cart.token);

      if (hasMismatch) {
        console.log('[Cart Fix] Mismatch detected - rendered:', renderedItems, 'dot:', renderedDotCount, 'actual:', actualItemCount);

        // Update cart-dot
        if (cartDot) {
          cartDot.innerHTML = actualItemCount > 0 ? actualItemCount : '';
          cartDot.classList.toggle('is-visible', actualItemCount > 0);
        }

        // Update cart-count
        if (cartCount) {
          cartCount.innerHTML = actualItemCount;
        }

        // Refresh cart drawer
        if (cartDrawer) {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }
      }

      lastKnownCartToken = cart.token;
    } catch (e) {
      console.error('[Cart Fix] Error checking cart:', e);
    }
  }

  // Check on pageshow (back/forward navigation)
  window.addEventListener('pageshow', (event) => {
    // Small delay to ensure DOM is ready
    setTimeout(checkAndRefreshCart, 100);
  });

  // Also check on popstate (browser back/forward)
  window.addEventListener('popstate', () => {
    setTimeout(checkAndRefreshCart, 100);
  });

  // Store token before leaving
  window.addEventListener('pagehide', async () => {
    try {
      const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      lastKnownCartToken = cart.token;
    } catch (e) {}
  });
})();

(function() {
  'use strict';

  const prefetchedUrls = new Set();

  function getFakeColorUrls(root) {
    return [...new Set(
      Array.from((root || document).querySelectorAll('[data-fake-color-link]'))
        .map((link) => link.href)
        .filter((href) => {
          if (!href) return false;

          try {
            const url = new URL(href, window.location.origin);
            return url.origin === window.location.origin && url.href !== window.location.href;
          } catch (error) {
            return false;
          }
        })
    )];
  }

  function prefetchUrl(url) {
    if (!url || prefetchedUrls.has(url)) return;

    const link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = url;
    link.as = 'document';

    document.head.appendChild(link);
    prefetchedUrls.add(url);
  }

  function updateSpeculationRules(root) {
    if (!window.HTMLScriptElement || typeof HTMLScriptElement.supports !== 'function' || !HTMLScriptElement.supports('speculationrules')) {
      return;
    }

    const urls = getFakeColorUrls(root);

    if (!urls.length) return;

    const existingRules = document.querySelector('[data-fake-color-speculation]');

    if (existingRules) {
      existingRules.remove();
    }

    const rulesScript = document.createElement('script');
    rulesScript.type = 'speculationrules';
    rulesScript.setAttribute('data-fake-color-speculation', '');
    rulesScript.textContent = JSON.stringify({
      prefetch: [
        {
          source: 'list',
          urls: urls
        }
      ]
    });

    document.head.appendChild(rulesScript);
  }

  function handleFakeColorInteraction(event) {
    const link = event.target.closest('[data-fake-color-link]');

    if (!link) return;

    prefetchUrl(link.href);
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateSpeculationRules(document);
  });

  document.addEventListener('pointerenter', handleFakeColorInteraction, true);
  document.addEventListener('focus', handleFakeColorInteraction, true);
  document.addEventListener('touchstart', handleFakeColorInteraction, { passive: true, capture: true });
  document.addEventListener('dialog:after-show', (event) => {
    updateSpeculationRules(event.target);
  });
})();
